import Image from '../image/Image';
import styles from './list-with-image.module.less';

export const ListWithImage = ({ informationList = [], className = '', imageSrc, imageAlt }) => {
    return (
        <div className={[className, styles.listWrapper].join(' ')}>
            <ul className={styles.list}>
                {informationList.map((item, index) => (
                    <li key={index} className={styles.listElement}>
                        {item}
                    </li>
                ))}
            </ul>
            {imageSrc && <Image className={styles.image} src={imageSrc} alt={imageAlt} role="presentation" />}
        </div>
    );
};
